import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";

// Thunk to fetch managed forms for the logged-in employee
export const fetchManagedForms = createAsyncThunk(
  "managedForms/fetchManagedForms",
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.authToken;
      const response = await getApi({
        apiUrl: API_URLS.GET_MANAGED_FORMS,
        token,
      });

      if (response?.success) {
        return response.data || [];
      }
      return rejectWithValue(
        response?.message || "Failed to fetch managed forms",
      );
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  },
);

const managedFormsSlice = createSlice({
  name: "managedForms",
  initialState: {
    managedForms: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearManagedFormsError(state) {
      state.error = null;
    },
    resetManagedForms(state) {
      state.managedForms = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchManagedForms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManagedForms.fulfilled, (state, action) => {
        state.loading = false;
        state.managedForms = action.payload;
      })
      .addCase(fetchManagedForms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearManagedFormsError, resetManagedForms } =
  managedFormsSlice.actions;
export default managedFormsSlice.reducer;
